import { render, staticRenderFns } from "./ExpensesCostsBox.vue?vue&type=template&id=11ea7255&"
import script from "./ExpensesCostsBox.vue?vue&type=script&lang=js&"
export * from "./ExpensesCostsBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports